import React from 'react';
import { Text } from 'components';
import { Link } from 'react-router-dom';
import { Routes } from 'core/routes.types';
import { MargedButton, MargedTitle } from './OrderConfirmation.style';

const OrderConfirmation: React.FunctionComponent = () => {
    return (
        <>
            <MargedTitle text="order_confirmation_title" type="large" />
            <Text text="order_confirmation_content" />
            <Link to={Routes.MenuHome}>
                <MargedButton fullWidth>
                    <Text text={'close'} weight="bold" />
                </MargedButton>
            </Link>
        </>
    );
};

export default OrderConfirmation;
